import Repository from './Repository';
import UserLogin from '@/models/User/UserLogin';
import UpdateUser from '@/models/User/UpdateUser';
import ChangePassword from '@/models/User/ChangePassword';
import { RequestResetPassword } from '@/models/User/RequestResetPassword';
import { ValidateResetPasswordToken } from '@/models/User/ValidateResetPasswordToken';
import { ResetPassword } from '@/models/User/ResetPassword';
import { ImpersonateUser } from '@/models/User/ImpersonateUser';
import UpdateLanguage from '@/models/User/UpdateLanguage';
import UpdateDatabase from '@/models/User/UpdateDatabase';
import ListRequest from '@/models/ListRequest';
import CreateAdminUser from '@/models/User/CreateAdminUser';
import UpdateAdminUser from '@/models/User/UpdateAdminUser';

const resource = '/users';

export default {
    fetchUserInfo() {
        return Repository.get(`${resource}/getloggedinuserdetails`, {withCredentials: true});
    },
    login(user: UserLogin) {
        return Repository.post(`${resource}/login`, user, {withCredentials: true});
    },
    logout() {
        return Repository.post(`${resource}/logout`, null, {withCredentials: true});
    },
    getUserProfile() {
        return Repository.get(`${resource}/getloggedinuserprofile`, {withCredentials: true});
    },
    updateUser(user: UpdateUser) {
        return Repository.post(`${resource}/updateuser`, user, {withCredentials: true});
    },
    changePassword(changePassword: ChangePassword) {
        return Repository.post(`${resource}/changepassword`, changePassword, {withCredentials: true});
    },
    requestResetPassword(requestResetPassword: RequestResetPassword) {
        return Repository.post(`${resource}/RequestResetPassword`, requestResetPassword);
    },
    validateResetPasswordToken(validateResetPasswordToken: ValidateResetPasswordToken) {
        return Repository.post(`${resource}/ValidateResetPasswordToken`, validateResetPasswordToken);
    },
    resetPassword(resetPassword: ResetPassword) {
        return Repository.post(`${resource}/ResetPassword`, resetPassword);
    },
    impersonateUser(impersonateUser: ImpersonateUser) {
        return Repository.post(`${resource}/ImpersonateUser`, impersonateUser, {withCredentials: true});
    },
    updateLanguage(language: UpdateLanguage) {
        return Repository.post(`${resource}/UpdateUserLanguage`, language, {withCredentials: true});
    },
    listAdminUsers(listRequest: ListRequest) {
        return Repository.post(`${resource}/ListAdminUsers`, listRequest, {withCredentials: true});
    },
    createAdminUser(createAdminUser: CreateAdminUser) {
        return Repository.post(`${resource}/CreateAdminUser`, createAdminUser, {withCredentials: true});
    },
    updateAdminUser(updateAdminUser: UpdateAdminUser) {
        return Repository.post(`${resource}/UpdateAdminUser`, updateAdminUser, {withCredentials: true});
    },
    deleteAdminUsers(ids: number[]) {
        return Repository.post(`${resource}/DeleteAdminUsers`, {ids: ids}, {withCredentials: true});
    },
};
